import {BackendCalculationOperator} from '@em/shared/mapping-engine/domain-models';

export const AvailableCalculationOperators: BackendCalculationOperator[] = [
  'plus',
  'minus',
  'multiple',
  'divide',
  'increase_by_percentage',
  'decrease_by_percentage',
];
